/* Icons */
import linkedIn from '../assets/img/nav-icon1.svg'
// import facebook from '../assets/img/nav-icon2.svg'
import instagram from '../assets/img/nav-icon3.svg'
import GitHub from '../assets/img/GitHub.png'

export const SERVER = window.location.protocol === 'http' ? "http://localhost:5000" : 'https://mymailsender.onrender.com';

export const Qualifications = ['Web Developer', 'Web Designer', 'UI/UX Designer'];

export const Biography = `Développeur full stack indépendant et autodidacte. Je suis passionné d'informatique et de nouvelles technologies et j'aime résoudre des problèmes de conception, créer des interfaces utilisateur intelligentes et travailler sur des problèmes de performances en arrière-plan.`

export const Menu = [
    {
        href: "#home",
        label: "Accueil"
    },
    {
        href: "#skills",
        label: "Habiletés"
    },
    {
        href: "#projects",
        label: "Projets"
    },
]

export const Social = [
    {
        id: 'social-media-1',
        icon: linkedIn,
        link: 'https://www.linkedin.com/in/orlando-guychard-731a15201'
    },
    {
        id: 'social-media-2',
        icon: GitHub,
        link: 'https://www.github.com/orlando-guy'
    },
    {
        id: 'social-media-3',
        icon: instagram,
        link: 'https://www.instagram.com/'
    },
]

/* Curriculom Vitae */
export const Practices = [
    {
        from: "Decembre 2021 À Maintenant (Hybride)",
        title: "Freelance",
        task: [
            "Référencement des sites web (SEO)",
            "Dévelopement d'application mobile (IOS, ANDROID)",
            "Conception des sites web",
            "Documentation et test du code",
            "Participation au développement et au déploiement des applications."
        ]
    },
    {
        from: "Avril 2021 À Novembre 2021 (Douala, Cameroun)",
        title: "Smart Business SARL",
        post: "Stagiaire Déeveloppeur",
        task: [
            "Référencement des sites web (SEO)",
            "Dévelopement d'application mobile (IOS, ANDROID)",
            "Conception des sites web",
            "Documentation et test du code",
            "Participation au développement et au déploiement des applications internes."
        ]
    },
    {
        from: "Novembre 2020 À Avril 2021 (Douala, Cameroun)",
        title: "Future Life Consulting",
        post: "Développeur Web",
        task: [
            "Création de site web",
            "Participation sur des projets internes",
            "participation à la maintenance des applications internes",
            "Proposition d'amélioration (fonctionnalité, ergonomie, etc) en lien avec les métiers."
        ]
    }
]

export const Studies = [
    {
        date: "04/2022",
        title: "Certification sur les fondamentaux du marketing digital",
        location: "Google Atelier Digital"
    },
    {
        date: "2021",
        title: "Etudiant, Licence 1 en informatique",
        location: "Université de Douala",
        place: "Douala, Cameroun"
    },
    {
        date: "2020",
        title: "Diplomé, Baccalauréat en Technologie de l'Information",
        location: "Lycée Joss",
        place: "Douala, Cameroun"
    },
]

export const WorkSkills = [
    {
        title: "VanillaJS",
        level: 55
    },
    {
        title: "AJAX",
        level: 45
    },
    {
        title: "PHP",
        level: 60
    },
    {
        title: "LARAVEL",
        level: null
    },
    {
        title: "Next Js",
        level: null
    },
    {
        title: "React JS",
        level: null
    },
    {
        title: "FLUTTER",
        level: null
    },
    {
        title: "SCSS",
        level: 50
    },
    {
        title: "Tailwindcss",
        level: 65
    },
    {
        title: "SQL",
        level: 50
    },
    {
        title: "SANITY",
        level: 40
    },
    {
        title: "WORDPRESS",
        level: null
    },
    {
        title: "GIT",
        level: null
    },
    {
        title: "SEO",
        level: null
    },
    {
        title: "XD",
        level: 80
    },
]
